import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <InformationalModule
  // configs
    sectionId='disability-insurance-product-intro'
    themeType='lightTheme'
    backgroundVariant='lightA'
    moduleName='intro-module'
    moduleVariation='A'
    disableBottomPadding={false}
    reverseContent={false}
    // content
    headingText={<>Disability insurance to fit <WidowBlock>your life.</WidowBlock></>}
    // column content
    introContent={(
      <>
        <Typography
          align='left'
          nextElement='button'>
          Did you know that that about one in four people will become disabled before age 67&#63;<sup>1</sup> Disability insurance is designed to protect your income by replacing a portion of your paycheck if you&#39;re ever too sick or injured to work. It lets you rest easy knowing that your expenses will be covered, keeping your lifestyle intact and your financial plan on track so you can focus on getting better.
        </Typography>
        <Link
          variant='buttonLinkPrimary'
          themeType='lightTheme'
          id='disability-insurance-product-intro-cta-fafa'
          ariaLabel='Learn how to protect your assets with a financial advisor'
          linkUrl='/find-a-financial-advisor/'>
          Get started
        </Link>
      </>
    )}
  />
);
